'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EventContact = function (_Component) {
  (0, _inherits3.default)(EventContact, _Component);

  function EventContact() {
    (0, _classCallCheck3.default)(this, EventContact);
    return (0, _possibleConstructorReturn3.default)(this, (EventContact.__proto__ || (0, _getPrototypeOf2.default)(EventContact)).apply(this, arguments));
  }

  (0, _createClass3.default)(EventContact, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          name = _props.name,
          phone = _props.phone,
          email = _props.email,
          url = _props.url;

      var contactInfo = [];

      if (name) contactInfo.push(name);
      if (phone) contactInfo.push(_react2.default.createElement(
        'a',
        { href: 'tel:+1-' + phone },
        phone
      ));
      if (email) contactInfo.push(_react2.default.createElement(
        'a',
        { href: 'mailto:' + email },
        email
      ));
      if (url) contactInfo.push(_react2.default.createElement(
        'a',
        { href: url, target: '_blank', rel: 'noopener noreferrer' },
        url
      ));

      if (contactInfo.length === 0) {
        return null;
      }

      return _react2.default.createElement(
        'div',
        { className: 'EventContact' },
        _react2.default.createElement(
          'ul',
          null,
          contactInfo.map(function (info, index) {
            return _react2.default.createElement(
              'li',
              { key: index },
              info
            );
          })
        )
      );
    }
  }]);
  return EventContact;
}(_react.Component);

EventContact.propTypes = {
  /**
   * The contact's name.
   */
  name: _propTypes2.default.string,
  /**
   * The contact's phone number.
   */
  phone: _propTypes2.default.string,
  /**
   * The contact's email address.
   */
  email: _propTypes2.default.string,
  /**
   * The contact's website.
   */
  url: _propTypes2.default.string
};
exports.default = EventContact;


//////////////////
// WEBPACK FOOTER
// ./~/caligram-react/dist/components/EventContact.js
// module id = 265
// module chunks = 0